export default "__VITE_ASSET__CSLNWPnW__"